import { gql } from 'apollo-boost'

export const MANUAL_ASSIGN = gql`
  mutation ManualAssign($data: ManualAssign) {
    ManualAssign(data: $data) 
  }
`